import React from "react";
import { Linkedin, Award } from "lucide-react";
import { jury } from "../data/mock";

export default function JuryPanel() {
  return (
    <section id="jury" className="relative py-24 bg-[#F0EFE8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#C4433D]/10 text-[#C4433D] mb-5">
            <Award className="w-4 h-4" />
            <span className="text-xs font-bold tracking-widest uppercase">Expert Jury</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#0f2a20] mb-4">
            Meet the jury panel.
          </h2>
          <p className="text-[#3a5148] text-lg leading-relaxed">
            A panel of scientists and industry leaders evaluating nominations
            with rigour, equity and vision.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {jury.map((j) => (
            <div
              key={j.name}
              className="group relative bg-white rounded-3xl overflow-hidden border border-[#1F5943]/10 hover:shadow-2xl transition-all duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden bg-[#1F5943]/5">
                <img
                  src={j.image}
                  alt={j.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="font-display text-xl text-[#0f2a20]">{j.name}</h3>
                    <div className="text-xs font-semibold tracking-wider uppercase text-[#C4433D] mt-1">
                      Jury Member
                    </div>
                  </div>
                  <a
                    href="#"
                    className="w-9 h-9 rounded-full bg-[#1F5943]/5 hover:bg-[#1F5943] hover:text-white flex items-center justify-center transition"
                  >
                    <Linkedin className="w-4 h-4" />
                  </a>
                </div>
                <p className="text-[#3a5148] text-sm leading-relaxed">{j.role}</p>
                <div className="mt-3 pt-3 border-t border-[#1F5943]/10 text-xs text-[#7a8b83] font-semibold">
                  {j.org}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center text-sm text-[#7a8b83]">
          More jury members to be announced soon.
        </div>
      </div>
    </section>
  );
}
